exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group label[data-v-6a7e2395] {\n    vertical-align: top;\n}\n.tooltip[data-v-6a7e2395] {\n    opacity: 1 !important;\n}\n", ""]);

// exports
